import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router";
import { Layout } from "./components/layout/Layout";
import { Home } from "./routes/Home";
import { SLUG_CONFIRMATION, SLUG_ORDER } from "./styles/slugs";
import {
  SLUG_CART,
  SLUG_CATEGORY,
  SLUG_PRODUCT,
  SLUG_FAVORITES,
  SLUG_ORDERS,
  SLUG_DELIVERY,
  SLUG_RECAP,
} from "./styles/slugs";

const Cart = lazy(() => import("./routes/Cart").then(m => ({ default: m.Cart })));
const Category = lazy(() => import("./routes/Category").then(m => ({ default: m.Category })));
const Confirmation = lazy(() => import("./routes/Confirmation").then(m => ({ default: m.Confirmation })));
const Delivery = lazy(() => import("./routes/Delivery").then(m => ({ default: m.Delivery })));
const Favorites = lazy(() => import("./routes/Favorites").then(m => ({ default: m.Favorites })));
const NotFound = lazy(() => import("./routes/404").then(m => ({ default: m.NotFound })));
const Order = lazy(() => import("./routes/Order").then(m => ({ default: m.Order })));
const Orders = lazy(() => import("./routes/Orders").then(m => ({ default: m.Orders })));
const Product = lazy(() => import("./routes/Product").then(m => ({ default: m.Product })));
const Recap = lazy(() => import("./routes/Recap").then(m => ({ default: m.Recap })));

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path={""} element={<Home />} />
          <Route path={`${SLUG_CART}/*`} element={<Suspense fallback={null}><Cart /></Suspense>} />
          <Route path={`${SLUG_DELIVERY}/*`} element={<Suspense fallback={null}><Delivery /></Suspense>} />
          <Route path={`${SLUG_RECAP}/*`} element={<Suspense fallback={null}><Recap /></Suspense>} />
          <Route path={`${SLUG_CONFIRMATION}/*`} element={<Suspense fallback={null}><Confirmation /></Suspense>} />
          <Route path={`${SLUG_FAVORITES}/*`} element={<Suspense fallback={null}><Favorites /></Suspense>} />
          <Route path={`${SLUG_ORDERS}/*`} element={<Suspense fallback={null}><Orders /></Suspense>} />
          <Route path={`${SLUG_ORDER}/:orderId/*`} element={<Suspense fallback={null}><Order /></Suspense>} />
          <Route
            path={`${SLUG_CATEGORY}/:categorySlug/*`}
            element={<Suspense fallback={null}><Category /></Suspense>}
          />
          <Route
            path={`${SLUG_PRODUCT}/:productSlug/*`}
            element={<Suspense fallback={null}><Product /></Suspense>}
          />
          <Route path="*" element={<Suspense fallback={null}><NotFound /></Suspense>} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
